<template>
  <div>
    <custom-result-not-found
      v-if="items.length === 0"
      text="La solicitud no cuenta con documentos asociados en sistema."
    />
    <div v-for="(data, index) in items" :key="index">
      <custom-callout
        class-main=" mt-3 border-0"
        :has-border="false"
        :has-gradient="false"
        :has-toggle="false"
      >
        <div class="row mr-md-0">
          <div class="col col-sm-3">
            <div class="color-gray-6 font-14">Tipo de Documento:</div>
            <div class="color-black font-16">
              {{ data.documentTypeDesc | empty }}
            </div>
          </div>
          <div class="col col-sm">
            <div class="color-gray-6 font-14">Nombre del Archivo:</div>
            <div class="color-black font-16">
              {{ data.attachment.name | empty }}
            </div>
          </div>
          <div class="col col-sm text-sm-right mt-3 mt-sm-1">
            <action-button
              i="fas fa-file-download mr-n1 pr-1"
              variant="success"
              @click="$emit('on-download-document', data)"
            />
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

export default {
  name: 'RequestDocumentsList',
  components: {
    CustomCallout,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
